/**
 * Refetching the rows a thread's visit cards read.
 *
 * A message carrying accept / decline / propose / share-availability rewrites the
 * visit, its time proposal and its time preference, and a card inside the thread reads
 * each of them by id (`useVisitProposal`, `useChannelTimePreference`, the
 * surfaces' visit blocks). A write that names its visit refreshes `visit.changed`
 * instead, which covers all three and the order's visit lists; this is for the writes
 * that cannot name one — a proposal that creates its visit, a deleted message that takes
 * its proposal with it — where the platform's own `visit.changed` (no origin) refreshes
 * the lists once it lands, and this refreshes the cards on screen now.
 *
 * Prefixes rather than ids: the visit is the unknown, and invalidation only refetches
 * the queries actually mounted.
 */

import { queryKeys, useInvalidateQueries } from "@birdwatch/client";
import { useCallback } from "react";

/** Every row a visit card reads, by prefix. */
export function visitCardKeys() {
  return [
    queryKeys.getVisitsByVisitId(),
    queryKeys.getTimeProposalsByTimeProposalId(),
    queryKeys.getTimePreferencesByTimePreferenceId(),
  ];
}

/** Returns a stable `invalidate()` covering every row a visit card reads. */
export function useVisitScenarioInvalidate() {
  const invalidate = useInvalidateQueries();

  return useCallback(() => invalidate(...visitCardKeys()), [invalidate]);
}
